export const resetStyles = `

/* Remove list styles (bullets/numbers) */
ol, ul, menu {
    list-style: none;
}

/* removes spacing between cells in tables */
table {
    border-collapse: collapse;
}

/* revert the 'white-space' property for textarea elements on Safari */
textarea {
    white-space: revert;
}

/* minimum style to allow to style meter element */
meter {
    -webkit-appearance: revert;
    appearance: revert;
}

/* reset default text opacity of input placeholder */
::placeholder {
    color: unset;
}

/* fix the feature of 'hidden' attribute.
   display:revert; revert to element instead of attribute */
:where([hidden]) {
    display: none;
}

/* revert for bug in Chromium browsers
   - fix for the content editable attribute will work properly. */
:where([contenteditable]) {
    -moz-user-modify: read-write;
    -webkit-user-modify: read-write;
    overflow-wrap: break-word;
    -webkit-line-break: after-white-space;
}

`;
export const mainStyle = `

.ck.ck-content {
  max-height: 30rem !important;
}

.ck-editor__editable {
  line-height: initial;
  padding: 24px;
  font-family: 'Mulish';
}
div, span, applet, object, iframe, h1, h2, h3, h4, h5, h6, p, blockquote, pre, a, abbr, acronym, address, big, cite, code, del, dfn, em, img, ins, kbd, q, s, samp, small, strike, strong, sub, sup, tt, var, b, u, i, center, dl, dt, dd, ol, ul, li, fieldset, form, label, legend, table, caption, tbody, tfoot, thead, tr, th, td, article, aside, canvas, details, embed, figure, figcaption, footer, header, hgroup, menu, nav, output, ruby, section, summary, time, mark, audio, video {
  font: revert;
}
ul, ol {
  list-style: initial;
  margin-left: 16px;
}
sub {
  vertical-align: sub !important;
}
sup {
  vertical-align: super !important;
}
h1, h2, h3, h4, h5{
  font-family: 'Mulish';
  color: #122340;
  font-style: normal;
  font-weight: bold;
  letter-spacing: 0;
}
h1{
  font-size: 28px;
  line-height: 40px;
  margin-top: 0;
  margin-bottom: 24px;
}
h2{
  font-size: 24px;
  line-height: 32px;
  margin-top: 0;
  margin-bottom: 16px;
}
h3{
  font-size: 20px;
  line-height: 24px;
  padding-left: 24px;
  margin-bottom: 16px;
  & + p{
      padding-left: 24px;
  }
}
h4{
  font-size: 16px;
  line-height: 24px;
}
h5{
  font-size: 14px;
  line-height: 20px;
}

p{
  color: #52567A;
  font-weight: 400;
  font-size: 16px;
  line-height: 28px;
  letter-spacing: 0.006em;
  padding:0px;
  margin-top:0;
  margin-bottom: 32px;
  
  a{
      color: #0072D6;
      font-weight: 700;
      text-decoration: underline;
      padding-right: 8px;
      &:after{
          display: inline-block;
          font-family: "Material Icons";
          position: relative;
          content: "launch";
          text-decoration: none;
          margin-left: 2px;
          line-height: 0;
          top: 3px;
      }
  }

  span.mjx-chtml.MathJax_CHTML{
      font-style: normal !important;
      font-weight: 400;
      font-size: 16px !important;
      line-height: 16px !important;
      letter-spacing: 0.006em;
      padding-top:0 !important;
      padding-bottom:0 !important;
      .MJXc-TeX-math-I{
          font-family: 'Mulish', sans-serif !important;
          font-size: 16px !important;
          padding-top:0 !important;
          padding-bottom:0 !important;
      }
  }
}

ul, ol{
  margin-top:0;
  margin-bottom: 32px;
  margin-left:0;
  padding-left: 39px;
  li{
      font-weight: 400;
      font-size: 16px;
      line-height: 28px;
      letter-spacing: 0.006em;
      color: #52567A;
  }
}

figure.table{
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 32px;
  padding:0;
  width: 100%;
  overflow-x: scroll;

  table{
      border-collapse: collapse;
      border: 1px solid #C4C9D8;
      padding: 0px;
      margin: 0 auto;
      width: auto;
      thead{
          background-color: #F4F6F6;
          tr{
              th{
                  border-right: 1px solid #C4C9D8;
                  font-weight: 700;
                  font-size: 18px;
                  line-height: 28px;
                  letter-spacing: 0.1px;
                  color: #2B3040;
                  text-align:left;
                  padding-left: 32px;
                  padding-right: 32px;
                  padding-top: 16px;
                  padding-bottom: 16px;
                  width: auto !important;
                  p{
                      font-weight: inherit;
                      font-size: inherit;
                      line-height: inherit;
                      letter-spacing: inherit;
                      color: inherit;
                      padding:0;
                      margin:0;
                  }
              }
          }
      }
  
      tbody{
          box-shadow: none;
          tr{
              th{
                  background-color: #F4F6F6;
              }
              td, th{
                  border-right: 1px solid #C4C9D8;
                  font-weight: 400;
                  font-size: 16px;
                  height: auto;
                  line-height: 28px;
                  letter-spacing: 0.006em;
                  color: #000;
                  padding-left: 32px;
                  padding-right: 32px;
                  padding-top: 16px;
                  padding-bottom: 16px;
                  p{
                      font-weight: inherit;
                      font-size: inherit;
                      line-height: inherit;
                      letter-spacing: inherit;
                      color: inherit;
                      padding:0;
                      margin:0;
                  }
              }
          }
      }
  }
}

a[href^="https://cerifi.widen.net/"]{
  font-weight: 700;
  font-size: 14px;
  line-height: 18px;
  letter-spacing: 0.5px;
  color: #007AFF;
  text-decoration: none;
  padding: 7px 10px;
  border-radius: 6px;
  background-color: transparent;
  &:hover{
      background-color: #E5F1FB;
  }
  &:before{
      font-family: "Material Icons Outlined";
      position: relative;
      content: "file_download";
      line-height: 0;
      margin-right: 3px;
      top:3px;
      font-size: 18px;
  }
  &:after{
      display: none;
  }
}
`;